import { store } from "store/configureStore";

export default function isTokenExpired() {
  const tokens = store.getState()?.auth?.data?.tokens ?? "";
  return new Date().getTime() > new Date(tokens?.access?.expires).getTime();
}
